<template>
  <div>
    <!--品牌展示 -->
    <div class="BrandDisplay" style="margin-left: 0px;">
      <a-page-header style="border: 1px solid rgb(235, 237, 240)" title="品牌展示" @back="() => null">
        <template slot="extra">
          <div style="float:right;">
            <a-input-search autosize="true" placeholder="input search text" style="width:200px;">
              <a-button slot="enterButton" icon="search" style="background:#207e63"> </a-button>
            </a-input-search>
          </div>
        </template>
      </a-page-header>
    </div>
    <div style="margin-top:15px;height:50px;margin-left: 0px;">
      <a-button class="BrandDisplaybtnTwo" @mouseenter="BrandEnter">知名品牌</a-button>
      <a-button class="BrandDisplaybtnTwo" @mouseenter="RegionalBrandEnter">区域品牌</a-button>
      <a-button class="BrandDisplaybtnTwo" @mouseenter="ProductsEnter">农产品品牌</a-button>
      <div style="float:right;line-height: 40px;">
        <a href="#" target="_blank" style="color:green">【农产品质量安全追溯】</a>
        <a href="#" target="_blank" style="color:green">【农产品质量安全追溯】</a>
      </div>
      <div style="clear: both;"></div>
    </div>
    <div style="border-style:solid;border-width:5px;border-color:#207e63;height:200px;">
      <!-- 内容 -->
      <a-row>
        <a-space direction="horizontal">
          <a-col :span="4" v-for="(item, index) of listData" :key="index" :value="item.title">
            <a-card hoverable >
              <img slot="cover" alt="example" :src="item.img_url" style="width: 160px;height:120px;overflow:hidden;" />
              <a-card-meta :title="item.bName" style="width: 160px;"> </a-card-meta>
            </a-card>
          </a-col>
        </a-space>
      </a-row>
    </div>
  </div>
</template>
<script>

import { BrandAgricultureProductsWebPage } from '@/api/main/BrandAgricultureProductsManager'
import { BrandPublicWebPage } from '@/api/main/BrandPublicManager'
export default {
  data() {
    return {
      listData: '',
      orgId: '',
      isfamous: '',
      syType: '',
      RegionalBrandisfull: false,
      RegionalBrandData: [],
      ProductsData: [],
      Productsusfull: false,
      Brandisfull: false,
      BrandData: [],
      Europe: ''
    }
  },
  methods: {
    RegionalBrandEnter() {
      this.syType = 'RegionalBrand'
      if (this.RegionalBrandisfull) {
        this.listData = ''
        this.listData = this.RegionalBrandData
      } else {
      this.loadData(this.syType)
      this.RegionalBrandisfull = true
      }
    },
    BrandEnter() {
      this.syType = 'Brand'
      if (this.Brandisfull) {
        this.listData = ''
        this.listData = this.BrandData
      } else {
      this.loadData(this.syType)
      this.Brandisfull = true
      }
    },
    ProductsEnter() {
     this.syType = 'Products'
      if (this.Productsusfull) {
        this.listData = ''
        this.listData = this.ProductsData
      } else {
      this.loadData(this.syType)
      this.Productsusfull = true
      }
    },
    loadData(syType) {
      this.orgId = this.$route.query.orgId
      if (syType === 'RegionalBrand') {
        BrandPublicWebPage({ orgId: this.orgId }).then(res => {
        this.RegionalBrandData = res.data.rows
      })
      } else if (syType === 'Brand') {
        BrandAgricultureProductsWebPage({ orgId: this.orgId, isfamous: 1 }).then(res => {
        this.BrandData = res.data.rows
      })
      } else if (syType === 'Products') {
        BrandAgricultureProductsWebPage({ orgId: this.orgId, isfamous: 0 }).then(res => {
        this.ProductsData = res.data.rows
        })
      }
    }
  }
}
</script>
<style>
.BrandDisplay {
  margin-top: 15px;
  margin-left: 0px;
  height: 65px;
  font-family: Arial;
  font-weight: 800;
  font-size: 16px;
  margin-left: 5px;
  background: #207e63;
}
.BrandDisplaybtn {
  width: 50px;
  height: 40px;
}
.BrandDisplaybtnTwo {
  width: 120px;
  height: 40px;
}
</style>
